import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import EditableContext from './EditableContext';
import { NEW_ITEM_VALUE } from './Constant';
import UserContext from '../../pages/layout/UserContext';
import checkPermission from '../Authorization/Util';

class EditableCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  componentDidMount() {}

  toggleEdit = () => {
    const value = this.context;
    const { parentType } = this.props;
    if (checkPermission(value, parentType, 'write')) {
      // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
        if (editing) {
          this.input.focus();
        }
      });
    }
  };

  save = e => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      this.toggleEdit();
      
      
      
      
      
      if (record.value !== values.value) {
        handleSave({ ...record, ...values });
      }
    });
  };

  renderCell = form => {
    this.form = form;
    const value = this.context;
    const { children, dataIndex, record, title } = this.props;
    const { editing } = this.state;
    const { parentType } = this.props;
    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`,
            },
          ],
          initialValue: record[dataIndex],
        })(
          <Input
            ref={node => {
              // eslint-disable-next-line no-return-assign
              return (this.input = node);
            }}
            onPressEnter={this.save}
            onBlur={this.save}
            disabled={!checkPermission(value, parentType, 'write')}
          />,
        )}
      </Form.Item>
    ) : (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      (<div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
        {record[dataIndex] === NEW_ITEM_VALUE ? this.toggleEdit() : null}
      </div>)
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      (<td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>)
    );
  }
}

EditableCell.propTypes = {
  record: PropTypes.object,
  handleSave: PropTypes.func,
  children: PropTypes.object,
  dataIndex: PropTypes.object,
  title: PropTypes.object,
  index: PropTypes.object,
  editable: PropTypes.object,
  parentType: PropTypes.string,
};

EditableCell.contextType = UserContext;

export default EditableCell;
